<template>
  <div id="hres7de-detail-tab3" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab3">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES7DEP3']['10'] }}
      </h3>
    </div>
    <div id="tab3" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
         <hrms-table  :columns="detailTab3Columns" 
                      :data="detailTab3" 
                      :editEvent="editEvent"
                      :maxRowspan="detailTab3MaxRowspan"
                       />

      </div>
    </div>

    <input data-toggle="modal" data-target="#hres7de-popup-tab3" ref="popup" type="hidden"/>
    <popup  :labels="labels"
            :labelsButton="labelsButton" 
            :nowLang="nowLang"
            :detailTab3Selected="detailTab3Selected"
            :detailTab3Popup="detailTab3Popup"
            :searchIndex="searchIndex"
            :codeval="codeval"
            :indexSelected="indexSelected"
            :postHres7deTab3PopupSave="postHres7deTab3PopupSave"
            :searchDetail="searchDetail"
            />

  </div>
</template>

<script>
import popup from 'components/hres7de/popupTab3'

export default {
  name: 'hres7de-detail-tab3',
  props: [ 'labels',
    'detailTab3',
    'detailTab3Columns',
    'labelsButton',
    'nowLang',
    'codeval',
    'searchIndex',
    'indexSelected',
    'detailTab3MaxRowspan',
    'detailTab3Selected',
    'setDetailTab3Selected',
    'detailTab3Popup',
    'postHres7deTab3PopupSave',
    'receivedHres7deDetailTab3Popup',
    'searchDetail' ],
  methods: {
    editEvent (param) {
      let paramsSearch = {
        p_dteyear: this.searchIndex.year,
        p_codcours: this.indexSelected.codcours,
        p_numclseq: this.indexSelected.numclseq,
        p_codinst: param.codinst,
        p_codsubj: param.codsubj,
        p_codform: param.codform
      }
      this.setDetailTab3Selected(param)
      this.receivedHres7deDetailTab3Popup(paramsSearch)
      this.$refs.popup.click()
    }
  },
  components: {
    popup
  }
}
</script>



// WEBPACK FOOTER //
// detailTab3.vue?55ee5643